import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'

const ResultView = () => {
  const isRequestUserInfo = useRef(false);
  const processAuthResult = async () => {
    try {

      if(isRequestUserInfo.current) {
        return;
      }
      isRequestUserInfo.current = true;

      // URL에서 쿼리 파라미터 파싱
      const params = new URLSearchParams(window.location.search)
      const queryParams: Record<string, string> = {}

      // 모든 쿼리 파라미터 추출 (디버깅용)
      params.forEach((value: string, key: string) => {
        queryParams[key] = value
      })

      const resultCode = params.get('resultCode')
      const resultMsg = params.get('resultMsg')

      // 결과가 성공인 경우 추가 정보 조회
      if (resultCode === '0000') {
        const authRequestUrl = params.get('authRequestUrl')
        const txId = params.get('txId')
        const token = params.get('token')

        console.log('인증 성공 파라미터:', { authRequestUrl, txId, token })

        // authRequestUrl, txId, token이 모두 있는 경우에만 API 호출
        if (authRequestUrl && txId && token) {
          try {
            // 백엔드 API를 통해 인증 결과 검증 및 추가 정보 조회
            const response = await axios.post(`${import.meta.env.VITE_API_URL_MY_SPACE}/auth/verify`, {
              authRequestUrl,
              txId,
              token
            })

            const resultData = {
              isDuplicate: response.data.isDuplicate,
              userDi: response.data.userDi,
              userCi: response.data.userCi,
              userName: response.data.userName,
              userPhone: response.data.userPhone,
              userBirth: response.data.userBirth,
              userGender: response.data.userGender,
              token
            }

            const result = {
              source: 'inisis_auth_result',
              success: true,
              data: resultData
            }
            window.opener.postMessage(result, window.location.origin);
            window.close();
          } catch (apiError) {
            const result = {
              success: false,
            }
            window.opener.postMessage(result, window.location.origin);
            window.close();
          }
        } else {
          console.warn('필수 인증 파라미터가 누락되었습니다:', {
            authRequestUrl,
            txId,
            token
          })
        }
      } else {
        console.log('인증 실패 코드:', resultCode, '메시지:', resultMsg)
        // 실패한 경우 기본 정보만 설정

      }
    } catch (err) {
      console.error('인증 결과 처리 중 오류:', err)
    }
  }
  processAuthResult();

  return null;
}

export default ResultView
